module.exports = __webpack_public_path__ + "img/lucas.7f1376d5.jpg";